import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

export interface IResultModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSendResult: boolean | undefined;
}

const ResultModal = ({ isOpen, onClose, isSendResult }: IResultModalProps) => {
  const { t } = useTranslation();
  // Отключаем по-тихоньку поддержку ТГ
  const qrLinkDisabled = true;

  const qrLink = `https://t.me/${process.env.REACT_APP_BOT_NAME}`;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      slotProps={{
        paper: { sx: { padding: { md: '30px 40px', xs: 2 }, margin: { xs: 2.5 } } },
      }}>
      <DialogTitle variant='h28' sx={{ paddingX: 0 }}>
        {t('assessment.resultModal.title')}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <DialogContentText>{t('assessment.resultModal.text_1')}</DialogContentText>
          <DialogContentText>{t('assessment.resultModal.text_2')}</DialogContentText>
          {isSendResult && (
            <>
              <DialogContentText>{t('assessment.resultModal.text_3')}</DialogContentText>
              <DialogContentText>{t('assessment.resultModal.text_5')}</DialogContentText>
            </>
          )}
          {!qrLinkDisabled && (
            <Link
              href={qrLink}
              target='_blank'
              sx={{
                width: 'fit-content',
                marginLeft: 'auto !important',
                marginRight: 'auto !important',
              }}>
              <QRCode size={150} style={{ opacity: 0.3 }} value={qrLink} viewBox='0 0 256 256' />
            </Link>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' size='large' fullWidth onClick={onClose}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResultModal;
